import { localizeUrlDomain } from "@dotcom/url";
import { Link } from "@polestar/component-warehouse-react";
import { type PropsWithChildren } from "react";

interface LocalizedLinkProps {
  readonly href: string;
  readonly target: string;
  readonly rel: string;
  readonly isChina: boolean;
  readonly className?: string;
}

const LocalizedLink = ({
  children,
  href,
  target,
  rel,
  isChina,
  className,
}: PropsWithChildren<LocalizedLinkProps>) => {
  return (
    <Link
      href={localizeUrlDomain(href, isChina)}
      className={className}
      target={target}
      rel={rel}
    >
      {children}
    </Link>
  );
};

export default LocalizedLink;
